/**
 * 部标机报警表格列配置
 */
import React from 'react';
import RenderEllipsisColumn from '@/components/renderEllipsisColumn';
import JtDeviceAlarmOperateColumn from '@/pages/jtDeviceAlarm/components/jtDeviceAlarmOperateColumn';
import {
  displayJtDeviceAlarm, displayJtDeviceAlarmV2,
  displayJtDeviceInfo
} from '@/utils/jtDeviceAlarm';
import { ownRound } from '@/utils/math';
import { formatTime } from '@/utils/formatTime';

// 表格列配置
export const jtDeviceAlarmColumns = [
  {
    title: '车牌号',
    dataIndex: 'plateNumber',
    width: 110,
    ellipsis: { showTitle: false },
    render: (value: string) => <RenderEllipsisColumn text={value} />
  },
  {
    title: '报警类型',
    dataIndex: 'contentMap',
    width: 120,
    ellipsis: { showTitle: false },
    render: (_: any, record: any) => {
      // 根据 record 中的两项值动态渲染
      const alarmType = record.alarmType;
      const warningType = record.warningType;
      return displayJtDeviceAlarmV2({
        alarmType,
        warningType
      });
    }
  },
  {
    title: '上报时间',
    dataIndex: 'reportedTime',
    width: 120,
    ellipsis: { showTitle: false },
    render: (value: string) => <RenderEllipsisColumn text={value} />
  },
  {
    title: '速度',
    dataIndex: 'speed',
    width: 90,
    ellipsis: { showTitle: false },
    render: (value: string) => <RenderEllipsisColumn text={ownRound(value, 1)} />
  },
  {
    title: '报警速度',
    dataIndex: 'speed1',
    width: 100,
    ellipsis: { showTitle: false },
    render: (value: string) => <RenderEllipsisColumn text={ownRound(value, 1)} />
  },
  {
    title: '车身速度',
    dataIndex: 'vehicleSpeed',
    width: 100,
    ellipsis: { showTitle: false },
    render: (value: string) => <RenderEllipsisColumn text={ownRound(value, 1)} />
  },
  {
    title: '操作',
    dataIndex: 'operate',
    width: 150,
    fixed: 'right' as const,
    render: (value: any, item: any) => (
      <JtDeviceAlarmOperateColumn
        alarmData={item}
        downloadPermissionKey="/car-admin/dvr-alarm/download-video"
      />
    )
  }
];
